export const EinsteinMoomjy = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="moomjyModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="col-lg-8">
                    <img
                      className="profile-image"
                      id="imageMainMoomjy"
                      src="/images/executioners/moomjy2.jpg"
                      alt="Einstein Moomjy advertisement"
                      style={{ margin: "10px 0" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <img
                      className="imageSubMoomjy"
                      src="/images/executioners/moomjy3.jpg"
                      alt="Einstein Moomjy advertisement detail"
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "10px 0",
                      }}
                    />
                    <img
                      className="imageSubMoomjy"
                      src="/images/executioners/moomjy.jpg"
                      alt="Einstein Moomjy advertisement detail"
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "10px 0",
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Einstein Moomjy
                    </h4>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      Establish Einstein Moomjy as the stylish/classy
                      alternative to cheesy/tacky carpet stores. Create consumer
                      attachment based on a created store personality. Change
                      the category of carpet store from generic to branded.
                    </p>
                    <p className="helvetica-nueue">
                      <strong>EXECUTION</strong>
                    </p>
                    <p>
                      These three ads are just a few of many in the amazingly
                      long-running campaign. With its punny, comic/ironic sense
                      of humor* and carefully crafted body copy (describing each
                      carpet/rug as if it were a piece of fine jewelry), this
                      campaign not only achieved the objective of attachment but
                      it’s often repeated consistent brand image won innumerable
                      awards throughout the years.{" "}
                    </p>
                    <p>*Special thanks to my mentor Carole Anne Fine</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
